import { lazy, Suspense, type ReactElement } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { SiteLayout } from '../shared/layout/SiteLayout';

const HomePage = lazy(() => import('../pages/HomePage').then((module) => ({ default: module.HomePage })));
const AboutPage = lazy(() => import('../pages/AboutPage').then((module) => ({ default: module.AboutPage })));
const LessonsPage = lazy(() =>
  import('../pages/LessonsPage').then((module) => ({ default: module.LessonsPage })),
);
const LessonPage = lazy(() =>
  import('../pages/LessonPage').then((module) => ({ default: module.LessonPage })),
);
const SeriesPage = lazy(() =>
  import('../pages/SeriesPage').then((module) => ({ default: module.SeriesPage })),
);
const QuizzesPage = lazy(() =>
  import('../pages/QuizzesPage').then((module) => ({ default: module.QuizzesPage })),
);
const QuizPage = lazy(() => import('../pages/QuizPage').then((module) => ({ default: module.QuizPage })));
const BlogPage = lazy(() => import('../pages/BlogPage').then((module) => ({ default: module.BlogPage })));
const BlogPostPage = lazy(() =>
  import('../pages/BlogPostPage').then((module) => ({ default: module.BlogPostPage })),
);
const ContactPage = lazy(() =>
  import('../pages/ContactPage').then((module) => ({ default: module.ContactPage })),
);
const AdminPage = lazy(() => import('../pages/AdminPage').then((module) => ({ default: module.AdminPage })));
const AccountPage = lazy(() =>
  import('../pages/AccountPage').then((module) => ({ default: module.AccountPage })),
);
const LoginPage = lazy(() => import('../pages/LoginPage').then((module) => ({ default: module.LoginPage })));
const NotFoundPage = lazy(() =>
  import('../pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })),
);

const page = (element: ReactElement) => (
  <Suspense fallback={<div aria-label="Загрузка страницы" style={{ minHeight: '70vh' }} />}>
    {element}
  </Suspense>
);

export const router = createBrowserRouter([
  { path: '/dashboard', element: page(<Navigate to="/dashboard/videos" replace />) },
  { path: '/dashboard/topics', element: page(<AdminPage section="topics" />) },
  { path: '/dashboard/series', element: page(<AdminPage section="series" />) },
  { path: '/dashboard/videos', element: page(<AdminPage section="videos" videoMode="list" />) },
  { path: '/dashboard/videos/new', element: page(<AdminPage section="videos" videoMode="create" />) },
  { path: '/dashboard/videos/:videoId/edit', element: page(<AdminPage section="videos" videoMode="edit" />) },
  { path: '/dashboard/assessments', element: page(<AdminPage section="assessments" />) },
  { path: '/dashboard/progress', element: page(<AdminPage section="progress" />) },
  { path: '/dashboard/access', element: page(<AdminPage section="access" />) },
  { path: '/admin', element: page(<Navigate to="/dashboard" replace />) },
  {
    element: <SiteLayout />,
    children: [
      { path: '/', element: page(<HomePage />) },
      { path: '/about', element: page(<AboutPage />) },
      { path: '/lessons', element: page(<LessonsPage />) },
      { path: '/lessons/:slug', element: page(<LessonPage />) },
      { path: '/series/:slug', element: page(<SeriesPage />) },
      { path: '/quiz', element: page(<QuizzesPage />) },
      { path: '/quiz/:slug', element: page(<QuizPage />) },
      { path: '/blog', element: page(<BlogPage />) },
      { path: '/blog/:slug', element: page(<BlogPostPage />) },
      { path: '/contact', element: page(<ContactPage />) },
      { path: '/login', element: page(<LoginPage />) },
      { path: '/account', element: page(<AccountPage />) },
      { path: '*', element: page(<NotFoundPage />) },
    ],
  },
]);
